export const CATEGORIES_SUGGEST = ['SSW', 'Magang', 'Bahasa Jepang', 'N4', 'N5', 'Lainnya']

export const CATEGORY_COLORS = {
  'SSW':          'bg-sky-100 text-sky-700',
  'Magang':       'bg-emerald-100 text-emerald-700',
  'Bahasa Jepang':'bg-violet-100 text-violet-700',
  'N4':           'bg-amber-100 text-amber-700',
  'N5':           'bg-rose-100 text-rose-700',
  'Lainnya':      'bg-gray-100 text-gray-700',
}

export function kategoriColor(k) {
  return CATEGORY_COLORS[k] || 'bg-gray-100 text-gray-700'
}

/** Normalise kategori field: could be array (JSON), legacy string, or null */
export function parseKat(k) {
  if (Array.isArray(k)) return k
  if (typeof k === 'string' && k) return [k]
  return []
}

export const GOLD = '#F59E0B'
